<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-3">
                <div class="title primary--text">
                    <h4>{{ $t("enrollment.steps.event_type_selection.component.title") }}</h4>
                </div>
                <div class="pt-1 secondary--text">{{ $t("enrollment.steps.event_type_selection.component.subtitle") }}</div>
            </v-flex>
            <v-flex xs12 mb-3>
                <v-form ref="eventTypeForm" onsubmit="return false;">
                    <v-layout v-if="screener" row wrap>
                        <v-radio-group hide-details class="radio-group-full-width my-3" row v-model="eventType" :mandatory="false">
                            <v-flex xs12 md6 v-for="(eventTypeItem,index) in eventTypes" :key="index">
                                <v-card
                                @click.stop="eventTypeItem.action(eventTypeItem.value)"
                                :class="[eventType == eventTypeItem.value ? 'border-box' : '', 'mx-auto cursor-pointer']"
                                height="100%"
                                >
                                    <v-card-title>
                                        <span class="title secondary--text">{{eventTypeItem.label}}</span>
                                    </v-card-title>
                                    <v-card-text class="">
                                        <v-layout justify-center wrap>
                                            <v-icon color="secondary" size="4em">{{eventTypeItem.icon}}</v-icon>
                                        </v-layout>
                                        <div class="secondary--text">
                                           <div>{{ moment.utc(screener.screening_starts_at).local().format("lll") }}</div>
                                           <div>{{screener.venue}}</div>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions class="px-3 justify-center">
                                        <v-radio color="secondary" class="ma-0" :value="eventTypeItem.value"></v-radio>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-radio-group>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '',]"
            color="primary background--text"
            dark
            @click="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}
            </v-btn>
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click="onConfirm"
            >{{ $t("enrollment.steps.continue.button") }}
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import DEFINES from "@/defines"

export default {
    name:"EnrollmentEventTypeSelection",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        screener:{
            type: Object,
            default: null
        }
    },
    data(){
        return{
            eventType: DEFINES.SCREENER_TYPE_VALUE.VIRTUAL, // Default
            eventTypes:[
                {
                    label:this.$t('screener.event_type.virtual.title'),
                    value:DEFINES.SCREENER_TYPE_VALUE.VIRTUAL,
                    action:this.setEventType,
                    icon: "mdi-desktop-mac"
                },
                {
                    label:this.$t('screener.event_type.physical.title'),
                    value:DEFINES.SCREENER_TYPE_VALUE.PHYSICAL,
                    action:this.setEventType,
                    icon: "mdi-theater"
                }
            ]
        }
    },
    methods:{
        onCancel(){
            this.$emit("onCancel",{});
        },
        onConfirm(){
            this.setEventType(this.eventType);
            this.$emit("onConfirm",{});
        },
        setEventType(eventType){
            this.eventType = eventType
            this.$emit("update:event_type",eventType)
        }
    }

}
</script>

<style scoped>
.border-box{
  border: 1px solid var(--v-secondary-base) !important;
  box-shadow: 0px 0px 3px 0px var(--v-secondary-base) !important;
}
.radio-group-full-width >>>.v-input__control {
    width: 100%  !important;
}
</style>
